import scopeLogger from 'lib/scope-logger.js';

const console = scopeLogger('RMI:creative:get-style-declaration');

export const getStyleDeclaration = {
  positions(selector, includeCssPosition = true) {
    return (variant) => {
      const { orientation, bottom, top, left } = variant;
      const properties = [['left', left]];

      if (includeCssPosition) {
        properties.push(['position', 'absolute']);
      }

      /*
        Due to the very first implementation was aimed to "popup" bottom is primary placement for
       */
      if (Number.isFinite(top?.value)) {
        properties.push(['top', top]);
      } else if (Number.isFinite(bottom?.value)) {
        properties.push(['bottom', bottom]);
      } else {
        console.warn(
          `missing property for vertical position for "${selector}"`,
        );
      }

      const rule = [selector, properties];
      if (orientation) {
        rule.push(`@media screen and (orientation: ${orientation})`);
      }
      return rule;
    };
  },
  size(selector) {
    return (variant) => {
      const { orientation, width, height } = variant;
      const rule = [
        selector,
        [
          ['width', width],
          ['height', height],
        ],
      ];

      if (orientation) {
        rule.push(`@media screen and (orientation: ${orientation})`);
      }
      return rule;
    };
  },
  scaleSize(selector, scale, mediaFeature) {
    return (variant) => {
      const { orientation, width, height } = variant;
      const rule = [
        selector,
        [
          ['width', width.mul(scale)],
          ['height', height.mul(scale)],
        ],
      ];
      if (orientation) {
        rule.push(
          `@media screen and (orientation: ${orientation}) and (${mediaFeature})`,
        );
      } else {
        rule.push(`@media screen and (${mediaFeature})`);
      }
      return rule;
    };
  },
};
